module.exports = __webpack_public_path__ + "static/media/letter(gray).4203aae6.svg";